import * as types from "./types";

const INITIAL_STATE = {
  list: {},
};

const note = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.CREATE_NOTE_RESPONSE:
      return {
        ...state,
        list: { ...action.payload },
      };

    case types.GET_NOTE_RESPONSE:
      return {
        ...state,
        list: { ...action.payload },
      };
    default:
      return state;
  }
};

export default note;
